(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["void-bundle-guide"]) return;
  try {
    
if (!customElements.get('void-bundle-builder')) {
 customElements.define('void-bundle-builder', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.initialized = true;
   this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
   this.s = this.config.strings;
   this.states = [{kind:'hoodies'}, {kind:'hoodies'}, {kind:'tees'}];
   this.button = this.querySelector('[data-bundle-add]');
   this.error = this.querySelector('[data-bundle-error]');
   this.grid = this.querySelector('[data-bundle-cards]');
   this.states.forEach((state,index) => this.createCard(state,index));
   this.button.addEventListener('click', () => this.addBundle());
   this.updateSummary();
  }
  node(tag,text,className) {
   const el=document.createElement(tag);
   if(text!==undefined) el.textContent=text;
   if(className) el.className=className;
   return el;
  }
  money(value) {
   return new Intl.NumberFormat(this.config.locale,{style:'currency',currency:this.config.currency}).format(value/100);
  }
  createCard(state,index) {
   state.products=this.config[state.kind].filter(p=>p.variants.some(v=>v.available));
   const card=this.node('article',undefined,'void-builder-card');
   card.append(this.node('h3',[this.s.hoodie_one,this.s.hoodie_two,this.s.tee][index]));
   state.image=this.node('img'); state.image.hidden=true; state.image.width=480;state.image.height=480;state.image.loading='lazy';
   card.append(state.image);
   const modelId='bundle-model-'+this.id+'-'+index;
   const label=this.node('label',this.s.model);label.htmlFor=modelId;card.append(label);
   state.select=this.node('select');state.select.id=modelId;
   state.select.append(new Option(this.s.choose_model,''));
   state.products.forEach(p=>state.select.append(new Option(p.title,String(p.id))));
   state.select.hidden=true;
   card.append(state.select);
   label.removeAttribute('for');
   const picker=this.node('details',undefined,'void-model-picker');
   const summary=this.node('summary',this.s.choose_model,'void-model-picker__summary');
   summary.setAttribute('aria-label',this.s.model+': '+this.s.choose_model);
   picker.append(summary);
   const gallery=this.node('div',undefined,'void-model-picker__gallery');
   gallery.setAttribute('role','group');gallery.setAttribute('aria-label',this.s.model);
   state.products.forEach(product=>{
    const option=this.node('button',undefined,'void-model-picker__option');
    option.type='button';option.setAttribute('aria-pressed','false');
    if(product.image){const image=this.node('img');image.src=product.image;image.alt='';image.width=180;image.height=180;image.loading='lazy';option.append(image);}
    option.append(this.node('span',product.title));
    option.addEventListener('click',()=>{
     state.select.value=String(product.id);
     state.select.dispatchEvent(new Event('change'));
     summary.replaceChildren();
     if(product.image){const image=this.node('img');image.src=product.image;image.alt='';image.width=44;image.height=44;summary.append(image);}
     summary.append(this.node('span',product.title));
     summary.setAttribute('aria-label',this.s.model+': '+product.title);
     gallery.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button===option)));
     picker.open=false;summary.focus();
    });
    gallery.append(option);
   });
   picker.append(gallery);
   picker.addEventListener('toggle',()=>{if(picker.open)this.querySelectorAll('.void-model-picker').forEach(other=>{if(other!==picker)other.open=false;});});
   card.append(picker);
   state.optionBox=this.node('div');card.append(state.optionBox);
   state.price=this.node('p',undefined,'void-builder-price');card.append(state.price);
   state.link=this.node('a',undefined,'void-builder-detail');state.link.hidden=true;card.append(state.link);
   this.grid.append(card);
   state.select.addEventListener('change',()=>{
    state.product=state.products.find(p=>String(p.id)===state.select.value);
    state.variant=null;state.optionBox.replaceChildren();state.options=[];
    if(state.product){
     state.image.src=state.product.image||'';state.image.alt=state.product.title;state.image.hidden=!state.product.image;
     state.link.href=state.product.url;state.link.textContent=state.product.title;state.link.hidden=false;
     state.product.options.forEach((name,optionIndex)=>{
      const id='bundle-option-'+this.id+'-'+index+'-'+optionIndex;
      const optionName=String(name).toLowerCase();const translatedName=/^(size|taglia|talla|größe)$/.test(optionName)?this.s.size:(/^(color|colour|colore|couleur)$/.test(optionName)?this.s.color:name);
      const label=this.node('label',translatedName);label.htmlFor=id;state.optionBox.append(label);
      const select=this.node('select');select.id=id;
      select.append(new Option(this.s.choose_option,''));
      const values=[...new Set(state.product.variants.filter(v=>v.available).map(v=>v.options[optionIndex]))];
      values.forEach(value=>select.append(new Option(value,value)));
      if(values.length===1)select.value=values[0];
      state.options.push(select);state.optionBox.append(select);
      select.addEventListener('change',()=>this.selectVariant(state));
     });
     this.selectVariant(state);
    } else {
     state.image.hidden=true;state.link.hidden=true;state.price.textContent='';this.updateSummary();
    }
   });
  }
  selectVariant(state) {
   const selected=state.options.map(s=>s.value);
   state.variant=state.product.variants.find(v=>v.available&&v.options.every((value,i)=>value===selected[i]))||null;
   state.options.forEach((select,i)=>{
    [...select.options].forEach(option=>{
     if(!option.value)return;
     option.disabled=!state.product.variants.some(v=>v.available&&v.options[i]===option.value&&selected.every((value,j)=>j===i||!value||v.options[j]===value));
    });
   });
   state.price.textContent=state.variant?(state.kind==='tees'?this.s.free+' · '+this.money(state.variant.price):this.money(state.variant.price)):(selected.every(Boolean)?this.s.unavailable:this.s.choose_option);
   if(state.variant&&state.variant.featured_image&&state.variant.featured_image.src){
    state.image.src=state.variant.featured_image.src;state.image.hidden=false;
   } else if(state.product.image){state.image.src=state.product.image;state.image.hidden=false;}
   this.error.hidden=true;
   this.updateSummary();
  }
  updateSummary() {
   const count=this.states.filter(s=>s.variant).length;
   this.querySelector('[data-bundle-progress]').textContent=this.s.progress.replace('{count}',String(count));
   const ready=count===3;
   this.button.disabled=!ready||this.busy;
   this.button.textContent=this.busy?this.s.adding:(ready?this.s.add:this.s.select_all);
   this.querySelector('[data-bundle-total]').textContent=ready?this.money(this.states[0].variant.price+this.states[1].variant.price):'—';
   this.querySelector('[data-bundle-saving]').textContent=ready?this.money(this.states[2].variant.price):'—';
  }
  async addBundle() {
   if(this.busy||this.states.some(s=>!s.variant))return;
   this.busy=true;this.error.hidden=true;this.updateSummary();
   const root=this.config.root.endsWith('/')?this.config.root:this.config.root+'/';
   try {
    const currentResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!currentResponse.ok)throw new Error(this.s.error_cart);
    const current=await currentResponse.json();
    const hoodieCount=current.items.filter(i=>this.config.hoodieIds.includes(String(i.product_id))).reduce((n,i)=>n+i.quantity,0);
    const hasTee=current.items.some(i=>this.config.teeIds.includes(String(i.product_id)));
    if(hoodieCount>=2&&hasTee)throw new Error(this.s.existing);
    const grouped=new Map();
    this.states.forEach(s=>grouped.set(s.variant.id,(grouped.get(s.variant.id)||0)+1));
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[...grouped].map(([id,quantity])=>({id,quantity}))})});
    const result=await response.json();
    if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.s.stock_changed);
    window.location.assign(this.config.cartUrl);
   } catch(error) {
    this.error.textContent=error.message||this.s.error;
    this.error.hidden=false;
    this.busy=false;this.updateSummary();
   }
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
